"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@lsg/utils");

var router_1 = require("@reach/router");

var React = __importStar(require("react"));

var CSSPrefix_1 = require("../../../base/CSSPrefix");

var Context_1 = require("./Context");

var AnimatedRouter =
/** @class */
function (_super) {
  __extends(AnimatedRouter, _super);

  function AnimatedRouter() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.popStateTimer = undefined;
    _this.state = {
      locations: [],
      isNext: undefined
    };

    _this.scheduleUpdate = function () {
      if (_this.popStateTimer !== undefined) {
        clearTimeout(_this.popStateTimer);
      } // TODO read from css


      _this.popStateTimer = setTimeout(_this.popState, 450);
    };

    _this.popState = function () {
      if (_this.state.locations.length > 2) {
        _this.scheduleUpdate();
      }

      _this.setState(function (prevState) {
        return __assign(__assign({}, prevState), {
          locations: prevState.locations.slice(1),
          isNext: undefined
        });
      });
    };

    return _this;
  }

  AnimatedRouter.prototype.componentWillUnmount = function () {
    if (this.popStateTimer !== undefined) {
      clearTimeout(this.popStateTimer);
    }
  };

  AnimatedRouter.prototype.render = function () {
    var _this = this;

    var children = this.props.children;
    var _a = this.state,
        locations = _a.locations,
        isNext = _a.isNext,
        prevPath = _a.prevPath;
    return React.createElement(Context_1.HistoryContext.Consumer, null, function () {
      return React.createElement(router_1.Location, null, function (_a) {
        var location = _a.location;
        var currentPath = location.pathname;

        if (currentPath !== prevPath) {
          var currentCounter_1 = window.history.state && window.history.state.counter;

          _this.setState(function (prevState) {
            return {
              prevPath: currentPath,
              prevCounter: currentCounter_1,
              locations: currentCounter_1 === undefined || locations.length >= 3 || locations.length === 0 ? __spreadArrays(prevState.locations.slice(0, -1), [location]) : __spreadArrays(prevState.locations, [location]),
              isNext: currentCounter_1 === undefined || locations.length === 0 ? undefined : !(prevState.prevCounter > currentCounter_1)
            };
          }, function () {
            return locations.length === 1 && _this.scheduleUpdate();
          });
        }

        var displayedLocations = isNext === false ? [locations[1], locations[0]] : locations.slice(0, 2);
        return locations.length === 0 ? React.createElement("div", {
          className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "animatedrouter"])
        }, React.createElement(router_1.Router, {
          location: location
        }, children)) : React.createElement("div", {
          className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "animatedrouter", isNext === true && CSSPrefix_1.lsgPre + "animatedrouter__next", isNext === false && CSSPrefix_1.lsgPre + "animatedrouter__previous"])
        }, displayedLocations.map(function (l) {
          return React.createElement("div", {
            className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "animatedrouter-inner"])
          }, React.createElement(router_1.Router, {
            location: l,
            primary: false
            /* prevent focus */

          }, children));
        }));
      });
    });
  };

  return AnimatedRouter;
}(React.Component);

exports.AnimatedRouter = AnimatedRouter;